import React, { useMemo } from 'react'
import { SelectProps, Space } from 'antd'
import { LockFilled } from '@ant-design/icons'
import { useSelector } from 'react-redux'
import { createLockedScenariosOptionsSelector } from '../../selectors/selectors'
import { disabledLockRender } from './disabledLockRender'
import CtxScenarioSelect from './CtxScenarioSelect'
import { useScenarios } from '../../queries/useScenarios'
import { contextCompanyIdSelector } from '../../../../redux/context/company/selectors'

interface CtxScenarioIconSelectProps extends SelectProps {
  disableLocked?: boolean
}

const CtxScenarioIconSelect = ({ disableLocked = false, ...props }: CtxScenarioIconSelectProps) => {
  const companyId = useSelector(contextCompanyIdSelector)!
  const { data: scenarios = [] } = useScenarios({ companyId })

  const optionSelector = useMemo(() => createLockedScenariosOptionsSelector(disableLocked), [disableLocked])

  const labelRender: SelectProps['labelRender'] = ({ value, label }) => {
    const scenario = scenarios.find(s => s.id === value)
    if (!scenario?.isLocked) return <>{label}</>
    return (
      <Space>
        <LockFilled />
        {label}
      </Space>
    )
  }

  return (
    <CtxScenarioSelect
      {...props}
      optionRender={disabledLockRender}
      optionSelector={optionSelector}
      labelRender={labelRender}
    />
  )
}

export default CtxScenarioIconSelect
